import {StorageWrapper} from '../../../shared/scripts/StorageWrapper'
import {MobileWebviewCommunicationActions} from '@colonist/mobile'
import {UIMMobileWebviewCommunication} from '../ui_mobile_communication/UIMMobileWebviewCommunication'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {TranslationObject} from '@colonist/i18n'
import {clientI18n} from '../../../shared/scripts/ClientI18n'
import {ClientUserState} from '../../../shared/scripts/ClientUserState'
import {uiManager} from '../EntryMobile'

export class UIMDeviceHandler {
    static KEYBOARD_HEIGHT_THRESHOLD = 550

    static updateUIFromStatusBarHeight(statusBarHeight: number, safeAreaInsetBottom: number) {
        const root = document.querySelector(':root') as HTMLElement
        root?.style.setProperty('--status-bar-height', `${statusBarHeight}px`)
        root?.style.setProperty('--safe-area-inset-bottom', `${Number(safeAreaInsetBottom) / 2}px`)
        StorageWrapper.setStatusBarHeight(statusBarHeight)
        StorageWrapper.setSafeAreaInsetBottom(safeAreaInsetBottom)
    }

    static initSavedInfoFromDevice() {
        const statusBarHeight = StorageWrapper.getStatusBarHeight()
        const safeAreaInsetBottom = StorageWrapper.getSafeAreaInsetBottom()

        const defaultStatusBarHeight = 24
        const defaultSafeAreaInsetBottom = 0
        UIMDeviceHandler.updateUIFromStatusBarHeight(statusBarHeight ?? defaultStatusBarHeight, safeAreaInsetBottom ?? defaultSafeAreaInsetBottom)
    }

    static requestNotificationPermission() {
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.RequestNotificationPermission)
    }

    static requestReview() {
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.RequestReview)
    }

    static showNotification(text: TranslationObject) {
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTextNotification, clientI18n.t(text.key, text.options))
    }

    static configureSafeArea() {
        const shouldShowSafeArea = UIUtilsEjsVariables.shouldDisplayNewMobileGameUI ? false : true
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTopBottomSafeArea, shouldShowSafeArea)
    }

    static getBuildNumber(): number | null {
        return StorageWrapper.getBuildNumber()
    }

    static getPlatform(): string | null {
        return StorageWrapper.getPlatform()
    }

    static getStatusBarHeight(): number {
        const defaultStatusBarHeight = 48
        return StorageWrapper.getStatusBarHeight() ?? defaultStatusBarHeight
    }

    static sendShareLink(link: string) {
        const buildNumber = UIMDeviceHandler.getBuildNumber() ?? 0
        const isNewBuild = buildNumber > 160
        const linkData = isNewBuild ? {
            message: '',
            title: 'Colonist Room',
            url: link,
        } : link
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShareLink, linkData)
    }

    static sendEventsOnAppLoad(): void {
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.LobbyLoaded)
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTopBottomSafeArea, false)
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowSplashScreen, false)

        const shouldSwitchToLandscape = UIUtilsEjsVariables.isUserOnTabletApp
        const currentBuildNumber = UIMDeviceHandler.getBuildNumber() ?? 0
        const isNewBuild = currentBuildNumber > 110
        UIMMobileWebviewCommunication.sendPayloadToMobile(shouldSwitchToLandscape && isNewBuild ? MobileWebviewCommunicationActions.OrientationLandscape : MobileWebviewCommunicationActions.OrientationPortrait)
    }

    static sendUserIdForNotifications() {
        const currentBuildNumber = UIMDeviceHandler.getBuildNumber() ?? 0
        const doesSupportNotifications = currentBuildNumber >= 180
        if(!doesSupportNotifications) return

        const userId = ClientUserState.userState?.id
        if(!userId) return

        StorageWrapper.setNotificationUserId(userId)
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.NotificationSetExternalUserId, userId)
    }

    static shouldEnableNativePaymentsOnMobile(): boolean {
        if(!UIUtilsEjsVariables.shouldEnableNativePaymentsOnMobile) return false
        const buildNumber = UIMDeviceHandler.getBuildNumber() ?? 0
        return buildNumber > 205
    }

    static async pauseForKeyboardToClose(): Promise<boolean> {
        const isKeyboardOpen = window.innerHeight < UIMDeviceHandler.KEYBOARD_HEIGHT_THRESHOLD
        if(!isKeyboardOpen) return false

        const shouldDelayLeaveRoom = uiManager.createRoomController.isCreateRoomButNotAHost()
        if(shouldDelayLeaveRoom) await new Promise((resolve) => setTimeout(resolve, 1000))
        return shouldDelayLeaveRoom
    }
}
